import React, { useEffect, useRef, useState } from 'react';
import { LogoContext, PRINT_WIDTH } from '..';
import { fontReport } from '../../../../apis/util';
import logo from '../../../../assets/logo_mini_yourfairshare2.png'
import { useContext } from 'react';
export const Cover = () => {
  const ref = useRef();
  const [width,setWidth] = useState(0)
  const logoInput = useContext(LogoContext)
  useEffect(() => {
    if (!ref.current) return; // wait for the elementRef to be available
    const resizeObserver = new ResizeObserver(() => {
      // Do what you want to do when the size of the element changes
      setWidth(ref.current.clientWidth)
    });
    resizeObserver.observe(ref.current);
    return () => resizeObserver.disconnect(); // clean up 
  }, []);
  return (<div className="output__cover" ref={ref}>
    <div className="cover__title">
      <h4 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.7/PRINT_WIDTH,"rem") }}><b>CoP</b> <i>Report</i></h4>
      <h6 style={{ fontSize: fontReport(width,PRINT_WIDTH,1/PRINT_WIDTH,"rem") }}><i>Communication on</i> <b>Progress</b></h6>
      <h6 style={{ fontSize: fontReport(width,PRINT_WIDTH,1/PRINT_WIDTH,"rem") }}><b>2023</b></h6>
    </div>
    <div className="w-100 d-flex align-items-center justify-content-center">
      <img src={logoInput}  style={{marginTop:"30%",width:fontReport(width,PRINT_WIDTH,359/PRINT_WIDTH,"px")}} alt="" />
    </div>
    {/* <img src={bubble1} alt="" />
        <img src={bubble2} alt="" />
        <img src={bubble3} alt="" />
        <img src={bubble4} alt="" /> */}
  </div>);
};
